import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.07558 10.8058L5.46284 15.1931C5.85336 15.5836 6.48653 15.5836 6.87705 15.1931L13.7274 8.34275C13.8253 8.24487 13.9018 8.12773 13.952 7.99876L15.2656 4.62826C15.4097 4.25854 15.3216 3.8386 15.041 3.55802L12.7322 1.24926C12.4535 0.970543 12.0371 0.881553 11.6688 1.02201L8.274 2.31671C8.14238 2.36691 8.02285 2.44435 7.92324 2.54396L1.07558 9.39162C0.685056 9.78214 0.685055 10.4153 1.07558 10.8058ZM9.94516 6.32357C10.6286 7.00699 11.7366 7.00699 12.42 6.32357C13.1034 5.64016 13.1034 4.53212 12.42 3.8487C11.7366 3.16528 10.6286 3.16528 9.94516 3.8487C9.26174 4.53212 9.26174 5.64016 9.94516 6.32357Z"
      fill="#183558"
    />
  </svg>
));
